module.exports = __webpack_public_path__ + "img/Unidad14-6.f71df4d7.png";